import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../i18n";
import { api } from "../../lib/api";

export default function ClientsList() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [orgs, setOrgs] = useState([]);
  useEffect(() => { api.get("/admin/clients").then((r) => setOrgs(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5 gc-fade-up">
      <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_clients")}</h1>
      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground text-xs"><tr>
            <th className="text-start px-4 py-3 font-medium">{t("company_name")}</th>
            <th className="text-start px-4 py-3 font-medium hidden sm:table-cell">{t("tin")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("your_plan")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("vat_health_score")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("status")}</th>
          </tr></thead>
          <tbody>
            {orgs.map((o) => (
              <tr key={o.id} data-testid={`client-row-${o.id}`} onClick={() => nav(`/app/clients/${o.id}`)} className="border-t border-border hover:bg-secondary/40 cursor-pointer">
                <td className="px-4 py-3 font-medium">{o.name}</td>
                <td className="px-4 py-3 hidden sm:table-cell font-mono text-xs">{o.tin || "—"}</td>
                <td className="px-4 py-3">{o.plan_id || "—"}</td>
                <td className="px-4 py-3 font-mono font-bold" style={{ color: o.health_score >= 70 ? "hsl(158 64% 28%)" : "hsl(38 92% 45%)" }}>{o.health_score || "—"}</td>
                <td className="px-4 py-3"><span className="text-xs text-[hsl(158_64%_28%)]">{o.subscription_status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
